<template>
    <div class="container">
        <div class="content">
            <p class="text">
                1.平台服务费计算：平台服务费是乘客总支付金额减掉驾驶员劳动报酬，去掉基础信息服务费等费用。
            </p>
            <p class="text">
                2.服务费说明：单笔订单平台服务费的计算结果受下单城市、服务时段、乘客优惠、司机补贴以及其他费用等因素影响会有所浮动。
                <!-- 平台服务费最高上限为 {{serviceCharegeMax | calcPriceFun}} 元。 -->
            </p>
            <p class="text">
                3.对订单费用详情如有疑问，请拨打万顺叫车客服电话400-6424-888咨询。
            </p>
        </div>
    </div>
</template>

<script>
import mobileType from "@/utils/mobileType";
import util from "@/utils/util";
import { getChargingCityDetailCar } from "@/apis/order/order";
export default {
    data() {
        return {
            serviceCharegeMax:null,
            userType: 1,
            orderType: null,
            channelType:1,
        };
    },
    created() {
        // window.getDataFromNative = this.getDataFromNative;
    },
    mounted() {
        // this.getUserInfoFromApp();
    },
    filters: {
        calcPriceFun(val) {
            return util.calcPrice(val);
        },
    },
    methods: {
        getUserInfoFromApp() {
            let params = {
                methodName: "getDataFromNative", //定义与原生的方法名(固定)
                type: 1, //业务类型(固定)
            };
            if (mobileType.isIOS()) {
                //vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
                window.webkit.messageHandlers.getDataFromVue.postMessage(
                    params
                );
            } else if (mobileType.isAndroid()) {
                //vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
                window.Android.getDataFromVue(JSON.stringify(params));
            } else {
            }
        },
        getDataFromNative(params) {
            if (mobileType.isIOS()) {
                this.params = params;
            } else if (mobileType.isAndroid()) {
                this.params = JSON.parse(params);
            }
            this.getInfo();
        },
        // 获取数据
        async getInfo() {
            let params;
            params = {
                areaCode: this.params.areaCode,
                channel: this.params.channel,
                deviceId: this.params.deviceId,
                display: this.params.display,
                imei: this.params.imei,
                imsi: this.params.imsi,
                platform: this.params.platform,
                softVersion: this.params.softVersion,
                sysVersion: this.params.sysVersion,
                data: {
                    cityCode: this.$route.query.cityCode,
                    areaCode:
                        this.params.areaCode || this.$route.query.cityCode,
                    userType:  this.$route.query.userType
                        ? this.$route.query.userType
                        : this.userType,
                    orderType: this.$route.query.orderType,
                    channelType: this.$route.query.channelType
                        ? this.$route.query.channelType
                        : this.channelType,
                    lat: this.$route.query.lat,
                    lon: this.$route.query.lon,
                    orderId: this.$route.query.orderId
                },
                token: this.params.token,
            };
            params.data = JSON.stringify(params.data);
            try {
                const data = await getChargingCityDetailCar(params);
                if (data.code == 1 && data.data) {
                    this.data = JSON.parse(data.data);
                    //  serviceCharegeMax
                    this.serviceCharegeMax = JSON.parse(
                        data.data
                    ).serviceCharegeMax;
                }
            } catch (error) {}
        },
    },
};
</script>
<style scoped lang="less">
.content {
    padding: 1.5rem;
    color: #333;
    .text {
        font-size: 0.9rem;
        line-height: 1.35rem;
        padding: 0.125rem 0;
    }
}
</style>